import React from "react";
import "./CustomerTable.css";

import {
  Eye,
  Mail,
  Trophy
} from "lucide-react";

const CustomerTable = ({
  customers = [],
  loading,
  onView
}) => {

  if (loading) {

    return (
      <div className="customer-table-card">
        <h3>Loading Customers...</h3>
      </div>
    );

  }

  return (

    <div className="customer-table-card">

      <table className="customer-table">

        <thead>

          <tr>

            <th>Customer</th>

            <th>Email</th>

            <th>Level</th>

            <th>Progress</th>

            <th>Achievements</th>

            <th>Status</th>

            <th>Last Active</th>

            <th></th>

          </tr>

        </thead>

        <tbody>

          {

            customers.length === 0 ?

            (

              <tr>

                <td
                  colSpan="8"
                  className="no-data"
                >

                  No Customers Found

                </td>

              </tr>

            )

            :

            customers.map((customer)=>(

              <tr key={customer.email}>

                <td>

                  <div className="customer-info">

                    <img

                      src={
                        customer.profilePhoto ||

                        "https://ui-avatars.com/api/?name=" +
                        encodeURIComponent(customer.name)

                      }

                      alt={customer.name}

                    />

                    <div>

                      <h4>{customer.name}</h4>

                      <span>{customer.phone}</span>

                    </div>

                  </div>

                </td>

                <td>

                  <div className="email-cell">

                    <Mail size={15}/>

                    {customer.email}

                  </div>

                </td>

                <td>

                  <span className="level-badge">

                    Level {customer.currentLevel}

                  </span>

                </td>

                <td>

                  <div className="progress-wrapper">

                    <div className="progress-bar">

                      <div

                        className="progress-fill"

                        style={{

                          width:

                          `${customer.progress || 0}%`

                        }}

                      />

                    </div>

                    <span>

                      {customer.progress || 0}%

                    </span>

                  </div>

                </td>

                <td>

                  <div className="achievement-cell">

                    <Trophy size={16}/>

                    {

                      customer.achievementCount ||

                      0

                    }

                  </div>

                </td>

                <td>

                  <span

                    className={`status

                    ${

                      customer.status === "Active"

                      ?

                      "active"

                      :

                      "pending"

                    }`}

                  >

                    {customer.status}

                  </span>

                </td>

                <td>

                  {customer.lastActive ||

                  "-"}

                </td>

                <td>

                  <button

                    className="view-btn"

                    onClick={()=>

                      onView(customer)

                    }

                  >

                    <Eye size={18}/>

                    View

                  </button>

                </td>

              </tr>

            ))

          }

        </tbody>

      </table>

    </div>

  );

};

export default CustomerTable;